<template>
  <v-slide-x-transition>
    <v-alert
      @input="onHide"
      :value="visible"
      dismissible
      colored-border
      :color="color"
      icon="mdi-clock-fast"
      border="left"
      class="noti-alert"
      elevation="2"
    >
      <div style="word-break: break-all">
        {{ text }}
      </div>
    </v-alert>
  </v-slide-x-transition>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      visible: state => state.notification.visible,
      text: state => state.notification.text,
      color: state => state.notification.color
    })
  },

  methods: {
    onHide() {
      this.$store.commit('notification/RESET_NOTIFICATION')
    }
  }
}
</script>

<style lang="scss" scoped>
.noti-alert {
  width: calc(360px - 16px);
  position: absolute;
  top: 70px;
  right: calc(0vw + 8px);
  z-index: 10;
}
</style>
